var CommunicationMappingModule = /** @class */ (function () {
    function CommunicationMappingModule() {
    }
    return CommunicationMappingModule;
}());
export { CommunicationMappingModule };
